import { render } from "./AddSunLight.vue?vue&type=template&id=1ba2518c"
import script from "./AddSunLight.vue?vue&type=script&lang=js"
export * from "./AddSunLight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__